import { Component, OnInit, OnDestroy } from '@angular/core';
import { CookieSettingsService } from '../../services/cookie-settings.service';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cookie-settings-button',
  templateUrl: './cookie-settings-button.component.html',
  styleUrls: ['./cookie-settings-button.component.css']
})
export class CookieSettingsButtonComponent implements OnInit, OnDestroy {
  hasCookieConsent = false;
  private consentCheckSubscription: Subscription;

  constructor(
    private cookieSettingsService: CookieSettingsService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    // Check initial consent status
    this.checkConsentStatus();

    // Listen to modal close to update button visibility
    this.consentCheckSubscription = this.cookieSettingsService.showSettings$.subscribe(show => {
      if (!show) {
        // Modal was closed, recheck consent status
        setTimeout(() => this.checkConsentStatus(), 100);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.consentCheckSubscription) {
      this.consentCheckSubscription.unsubscribe();
    }
  }

  private checkConsentStatus(): void {
    const cookieInfo = this.storageService.getCookie('tresInfo');
    this.hasCookieConsent = cookieInfo.length > 0;
  }

  openCookieSettings(): void {
    this.cookieSettingsService.openSettings();
  }
}
